import { configureStore, combineReducers } from "@reduxjs/toolkit"
import createSagaMiddleware from "redux-saga";
import { watcherSaga } from "./sagas/rootSaga";

import uiSlice from "./slices/ui"
import authSlice from "./slices/auth"
import alertSlice from "./slices/alerts"
import accountUsersSlice from "./slices/users"
import config from "./slices/config";
import error from "./slices/error";
import skillSlice from "./slices/skill";
import projectSlice from "./slices/project";
import refreshTriggersSlice from "./slices/refreshTriggers";
import registerSlice from "./slices/register";
import notificationSlice from "./slices/notification";
import quoteReducer from "./slices/quote";
import calendarReducer from "./slices/calendar";
import retainerStatusReducer from "./slices/retainerStatus";
import suggestionReducer from "./slices/suggestion";

const reducer = combineReducers({
    ui: uiSlice,
    auth: authSlice,
    alerts: alertSlice,
    config: config,
    errors: error,
    skills: skillSlice,
    project: projectSlice,
    accountUsers: accountUsersSlice,
    refreshTriggers: refreshTriggersSlice,
    register: registerSlice,
    notifications: notificationSlice,
    quote: quoteReducer,
    calendar: calendarReducer,
    retainerStatus: retainerStatusReducer,
    suggestion: suggestionReducer,
});

const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, thunk: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(watcherSaga);

let lastMode = store.getState().ui.theme.mode;
let lastNavCollapsed = store.getState().ui.navCollapsed;
store.subscribe(() => {
    const mode = store.getState().ui.theme.mode;
    if (mode !== lastMode) {
        lastMode = mode;
        try {
            localStorage.setItem("themeMode", mode);
        } catch (e) {}
    }

    const navCollapsed = store.getState().ui.navCollapsed;
    if (navCollapsed !== lastNavCollapsed) {
        lastNavCollapsed = navCollapsed;
        try {
            localStorage.setItem("navCollapsed", navCollapsed ? "true" : "false");
        } catch (e) {}
    }
});

export default store;